import { Menu, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';

import scssVariables from 'styles/sass-variables.module.scss';

export const TitleMenuItem = styled(MenuItem)(() => ({
  pointerEvents: 'none',
  color: scssVariables.text_secondary,
}));

export const MenuStyled = styled(Menu)<{ isEng?: boolean }>(({ isEng }) => ({
  '& .MuiPaper-root': {
    width: isEng ? '240px' : '300px',
    borderRadius: '8px',
    boxShadow: '8px 8px 8px 0px rgba(62, 59, 81, 0.06), -8px 0px 8px 0px rgba(62, 59, 81, 0.06)',
  },
  '& .MuiList-root': {
    padding: '4px 0px',
  },
  '& .MuiMenuItem-root': {
    height: '44px',
  },
}));
